import { en } from "./en.js";
import { sr } from "./sr.js";
import type { SiteText } from "./types.js";

/**
 * Тексты сайта по языкам. Новый язык: файл той же формы (`SiteText`) и строка здесь; переключатель в `SiteLayout`
 * и выбор языка в `useSiteLang` берут список из `siteLangs`.
 */
export const siteText = { sr, en } satisfies Record<string, SiteText>;
export type SiteLang = keyof typeof siteText;
export const siteLangs = Object.keys(siteText) as SiteLang[];
export type { SiteText } from "./types.js";
